import {FireInTheHole2} from "../../FireInTheHole2";
import {gsap} from "gsap";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

export class FreespinAfterIntroPresentation implements FlowStatePresentation {
    name: string = "FreespinAfterIntroPresentation";

    shouldRun(): boolean {
        return FireInTheHole2.model.freespinTriggeredThisSpin;
    }

    start(controller: FlowStateController): void {
        const tl = gsap.timeline();
        const dirtRowsToRemove: number = Math.min(2, FireInTheHole2.model.data.scatterCount - 3);
        //1 second is waiting for wagon goes out
        tl.add([
            FireInTheHole2.gameViewContainer.scaleUp(),
            //FireInTheHole2.multiplier.scaleUp(),
            //FireInTheHole2.fsLeftView.scaleUp()
        ], 1);
        if (dirtRowsToRemove > 0) {
            tl.add(FireInTheHole2.freespinReelArea.removeDirtRows(dirtRowsToRemove), 2);
        }
        tl.add(() => controller.finish(), `+=${dirtRowsToRemove > 0 ? 0.5 : 0.1}`);
    }
}